module.exports = __webpack_public_path__ + "static/adult-with-phone-e9ad016806ccee85d72e2e1dd0717d03.jpg";